/**
 * Dropdown layout normalization (question-set–like defaults).
 */

import type { QtDropdownLayoutConfig } from './schema';

export type QtDropdownPanelArrangement = 'horizontal' | 'vertical';

export function normalizeQtDropdownPanelArrangement(
    raw: string | undefined,
): QtDropdownPanelArrangement {
    if (raw === 'vertical') {
        return 'vertical';
    }
    return 'horizontal';
}

export function normalizeQtDropdownLayoutConfig(
    layout: QtDropdownLayoutConfig | undefined | null,
): QtDropdownLayoutConfig & { type: QtDropdownPanelArrangement } {
    const base = (layout ?? {}) as Partial<QtDropdownLayoutConfig>;
    const type = normalizeQtDropdownPanelArrangement(base.type as string | undefined);
    return {
        ...(base as QtDropdownLayoutConfig),
        type,
    };
}
